import React, { useCallback, useEffect } from "react";
import { auctionV2ApiClient } from "./AuctionApiClient";
import AuctionLots from "../components/auctionLots/AuctionLots";
import logger from "../utils/logger";
export function LatestAuctionLots({ numberOfProducts, auctionUrl, strings, categoryId, sortOrder }) {
    const getItems = useCallback(async () => {
        return await auctionV2ApiClient.searchItems({
            limit: numberOfProducts,
            filterCategoriesIds: categoryId,
            sortOrder,
        });
    }, []);
    useEffect(() => {
        logger.pageView();
    }, []);
    return (React.createElement(AuctionLots, { auctionUrl: auctionUrl, strings: strings, getItems: getItems, auctionStatus: 0, showOnlyActive: false, saveItemPositionState: () => { }, itemsPerPageLimit: numberOfProducts }));
}
